export default [
  {
    header: 'PLEASE LOG IN',
  },
  {
    header: '. . . . . . . . . . . . . . . . . . . . . . . . . . . . . .',
  },
]
